export default `
  {
    profile {
      showDenounceReminder
    }
  }
`;